export default `
  {
    profile {
      showDenounceReminder
    }
  }
`;